import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import ReactGA from 'react-ga4';

import { QueryClient, QueryCache, QueryClientProvider } from 'react-query';

import 'moment/locale/nl';
import 'moment/locale/de';

import 'babel-polyfill/browser';

// Importing everything from bootstrap is not needed. Only the css is enough.
// Can be replaced by installing bootstrap(^5.0.1) and importing like: import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-styles/css/bootstrap.min.css';

import 'react-widgets/scss/styles.scss';
import './assets/style/App.scss';
import './assets/style/Dashboard.scss';
import 'react-notifications-component/dist/theme.css';

import { Auth0Provider } from './providers/Auth0Provider';
import AxiosProvider from './providers/AxiosProvider';
import AppRouter from './router/AppRouter';
import { store } from './store';
import history from './utils/HistoryService';
import { handleNetworkError } from './actions/network-errors/network-errors';
import Config from './config';

const rootElement = document.getElementById('root');
const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      store.dispatch(
        handleNetworkError(
          error?.response,
          null,
          query?.options?.notificationNamespace
        )
      );
    },
  }),
});

ReactGA.initialize([
  {
    trackingId: process.env.REACT_APP_GOOGLE_ANALYTICS,
    gaOptions: {
      anonymizeIp: true,
    },
  },
]);

Config.Localization.init();

const onRedirectCallback = (appState) => {
  history.push(
    appState && appState.targetUrl ? appState.targetUrl : '/mobile/trip'
  );
};

ReactDOM.render(
  <Auth0Provider
    domain={process.env.REACT_APP_AUTH_CONFIG_DOMAIN}
    client_id={process.env.REACT_APP_AUTH_CONFIG_CLIENT_ID}
    redirect_uri={process.env.REACT_APP_AUTH_CONFIG_CALLBACK_URL}
    audience={process.env.REACT_APP_AUTH_CONFIG_AUDIENCE}
    scope={process.env.REACT_APP_AUTH_CONFIG_SCOPE}
    onRedirectCallback={onRedirectCallback}
  >
    <AxiosProvider>
      <QueryClientProvider client={queryClient}>
        <Provider store={store}>
          <AppRouter />
        </Provider>
      </QueryClientProvider>
    </AxiosProvider>
  </Auth0Provider>,
  rootElement
);
